import { useId } from "react";
import Select from "react-select";
import { displayMoney } from "../../../utils/displayMoney";
import "./styles.scss";

type Props = {
  costs: ManufacturingCost[];
  value: string;
  onChange: (id: string) => void;
  label?: string;
};

const WorkmanshipSelect = ({ costs, value, onChange, label = "Hechura:" }: Props) => {
  const id = useId();
  const options = costs.map((cost) => ({
    value: cost._id || "", label: `${cost.description} - ${displayMoney(cost.value)}`,
  }));
  return (
    <div className="workmanship-select" onKeyDown={(event) => {
      // Runs after react-select's own keyboard handling, including selection.
      if (event.key === "Enter") event.preventDefault();
    }}>
      <Select
        inputId={id}
        instanceId={id}
        aria-label={label}
        name="manufacturingCostId"
        options={options}
        value={options.find((option) => option.value === value) || null}
        onChange={(option) => option && onChange(option.value)}
        isSearchable
        blurInputOnSelect={false}
        placeholder="Seleccione"
        noOptionsMessage={() => "Sin resultados"}
        filterOption={(option, query) => option.label.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase())}
        menuShouldScrollIntoView={false}
        maxMenuHeight={220}
        styles={{
          control: (base) => ({ ...base, minHeight: 30, border: 0, boxShadow: "none" }),
          valueContainer: (base) => ({ ...base, padding: "0 6px" }),
          indicatorsContainer: (base) => ({ ...base, height: 30 }),
          dropdownIndicator: (base) => ({ ...base, padding: 4 }),
          menu: (base) => ({ ...base, zIndex: 10 }),
        }}
      />
    </div>
  );
};

export default WorkmanshipSelect;
